import React from "react";
import { useTranslation } from "react-i18next";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import { FormInput, FormTextArea } from "@/shared/Components";
import type { FieldProps } from "@/pages/ContactsPage/types";

export const Competences: React.FC<FieldProps> = ({ index }) => {
  const { t } = useTranslation();

  return (
    <FieldLayout>
      <FormInput
        name={`competences.${index}.competenceType.name`}
        placeholder={t("contactsPage.activities.competence")}
      />
      <FormTextArea name={`competences.${index}.about`} placeholder={t("common.about")} />
    </FieldLayout>
  );
};
